import React from 'react'

import HeaderMeta from 'components/HeaderMeta'

import Content from 'components/base/Content'
import Img from 'components/base/Img'
import InputGroup from 'components/base/Form/InputGroup'
import { Type as InputType } from 'components/base/Form/Input'
import Link from 'components/base/Link'
import Loading from 'components/base/Loading'
import Paragraph from 'components/base/Paragraph'
import SelectOption from 'components/base/Form/Input/Select/Option'
import Title from 'components/base/Title'

import BlogPostsGrid from 'components/blocks/Blog/PostsGrid'
import { ContentWrapper } from 'components/blocks/Blog/ContentWrapper/styles'
import CtaQuote from 'components/blocks/CtaQuote'
import PageHero, { Theme as PageHeroTheme } from 'components/blocks/PageHero'
import PostTagsList from 'components/blocks/Blog/PostTagsList'

import { tagsHardcodedContent } from '..'

import { Props } from './types'

import {
  FeaturedPost,
  FeaturedPostImg,
  FeaturedPostImgFrame,
  FeaturedPostTitle,
  GridHeader,
  GridHeaderFilter,
} from './styles'

const BlogLanding: React.FC<Props> = ({
  featuredPost,
  isFeaturedPostLoading,
  onChangeTagFilter,
  selectedTagSlugFilter,
  tags,
}): React.ReactElement => (
  <>
    <HeaderMeta
      title='Blog | Insurance Lounge'
      description='Learn everything you need to know about optimizing your insurance strategy on the Insurance Lounge blog. Find out more about home, auto, life, and health insurance today.'
      ogImg='/images/og-images/About.webp'
    />
    <PageHero theme={PageHeroTheme.press}>Our Blog</PageHero>

    {(isFeaturedPostLoading && (
      <Content margined={true}>
        <Loading />
      </Content>
    )) || (featuredPost && (
      <Content margined={true}>
        <FeaturedPost>
          <FeaturedPostImg>
            <FeaturedPostImgFrame>
              {featuredPost.featured_image && (
                <Link to={`/blog/posts/${featuredPost.slug}`}>
                  <Img
                    src={featuredPost.featured_image.url}
                    src2x={undefined}
                    alt={featuredPost.featured_image.alt}
                  />
                </Link>
              )}
            </FeaturedPostImgFrame>
          </FeaturedPostImg>
          <article>
            <FeaturedPostTitle level={3}><Link to={`/blog/posts/${featuredPost.slug}`}>{featuredPost.title}</Link></FeaturedPostTitle>
            <ContentWrapper><p dangerouslySetInnerHTML={{ __html: featuredPost.description }} /></ContentWrapper>

            <Paragraph>
              <Link to={`/blog/posts/${featuredPost.slug}`}>Read Full Post</Link>
            </Paragraph>

            <PostTagsList tags={featuredPost.tags} />
          </article>
        </FeaturedPost>
      </Content>
    ))}

    <CtaQuote
      trackingInfo={{
        button_position: 'middle',
        page_category: 'blog',
      }}
    />

    <Content margined={true}>
      <GridHeader>
        <Title level={2} alignLeft={true}>
          Recent Posts
        </Title>
        {(tags && (
          <GridHeaderFilter>
            <InputGroup
              type={InputType.select}
              label='Topic List:'
              value={selectedTagSlugFilter}
              onChange={onChangeTagFilter}
            >
              <>
                <SelectOption value=''>
                  All Insurance
                </SelectOption>
                {tags.map(tag => (
                  <SelectOption
                    key={tag.slug}
                    value={tag.slug}
                  >
                    {tagsHardcodedContent[tag.slug]?.title || tag.name}
                  </SelectOption>
                ))}
              </>
            </InputGroup>
          </GridHeaderFilter>
        ))}
      </GridHeader>
      <BlogPostsGrid tagSlugs={selectedTagSlugFilter} />
    </Content>
  </>
)

export default BlogLanding
